import Axios from 'axios';
import { getServerURL } from 'src/modules/debug/utils';
const axios = Axios.create();
// ponytail: same New Arch RNUC timing issue as httpLink — don't freeze baseURL
// at module load.
axios.interceptors.request.use(request => {
    request.baseURL = getServerURL();
    return request;
});
export default function getAxiosInstance() {
    return axios;
}
